module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "tab-tasks-wrapper"
    }
  }, [(_vm.isLoadingTaskData) ? _c('div', {
    staticClass: "col-md-12 col-sm-10",
    attrs: {
      "id": "tasks-loading"
    }
  }, [_c('div', {
    staticClass: "loadingData"
  })]) : (_vm.noTasksBonded) ? _c('div', [_c('div', {
    staticClass: "vertical-center loading-center"
  }, [_c('div', {
    staticClass: "image-container"
  }, [_vm._m(0), _c('br'), _c('p', {
    staticClass: "big-txt-allotment",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('modalDetalhesLanc.tabTarefas.labels.msgNenhumaTarefa'))
    }
  }), (_vm.canPerformTaskAction) ? _c('button-primary', {
    staticClass: "primary",
    attrs: {
      "label": _vm.$t('modalDetalhesLanc.tabTarefas.labels.iniciarTarefa'),
      "faIcon": "",
      "id": "btnTabLoteConcManual",
      "clickFunction": _vm.startTask,
      "customClass": "big-primary"
    }
  }) : _vm._e()], 1)])]) : (_vm.createEditTask) ? _c('div', {
    attrs: {
      "id": "create-edit-task-form"
    }
  }, [(!_vm.isVisualisingTask) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-group col-xs-8"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "taskName"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('tarefaEmMassa.labels.nome'))
    }
  }), _c('label', {
    staticClass: "control-label required-label"
  }, [_vm._v("*")]), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true
        }
      }),
      expression: "{ rules: { required: true } }"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.currentTask.nome),
      expression: "currentTask.nome"
    }],
    staticClass: "form-control",
    class: {
      'input': true,
      'is-danger': _vm.errors.has('taskName')
    },
    attrs: {
      "type": "text",
      "id": "taskName",
      "name": "taskName",
      "maxlength": "100",
      "tabindex": "0"
    },
    domProps: {
      "value": (_vm.currentTask.nome)
    },
    on: {
      "change": function($event) {
        return _vm.setTask('nome', _vm.currentTask.nome)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentTask, "nome", $event.target.value)
      }
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.firstByRule('taskName', 'required')),
      expression: "errors.firstByRule('taskName', 'required')"
    }],
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('validacao.campoObrigatorio'))
    }
  })]), _c('div', {
    staticClass: "form-group col-xs-4"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "taskType"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('tarefaEmMassa.labels.tipoVinculo'))
    }
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.task.tipoVinculo.nome),
      expression: "task.tipoVinculo.nome"
    }],
    staticClass: "form-control",
    class: {
      'input': true,
      'is-danger': _vm.errors.has('taskType')
    },
    attrs: {
      "type": "text",
      "id": "taskType",
      "name": "taskType",
      "maxlength": "2",
      "disabled": "disabled"
    },
    domProps: {
      "value": (_vm.task.tipoVinculo.nome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.task.tipoVinculo, "nome", $event.target.value)
      }
    }
  })])]) : _vm._e(), (!_vm.isVisualisingTask) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "taskDes"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('tarefaEmMassa.labels.descricao'))
    }
  }), _c('label', {
    staticClass: "control-label required-label"
  }, [_vm._v("*")]), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true
        }
      }),
      expression: "{ rules: { required: true } }"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.currentTask.descricao),
      expression: "currentTask.descricao"
    }],
    staticClass: "form-control",
    class: {
      'input': true,
      'is-danger': _vm.errors.has('taskDes')
    },
    attrs: {
      "type": "text",
      "id": "taskDes",
      "name": "taskDes",
      "maxlength": "1000",
      "rows": "2",
      "cols": "130"
    },
    domProps: {
      "value": (_vm.currentTask.descricao)
    },
    on: {
      "change": function($event) {
        return _vm.setTask('descricao', _vm.currentTask.descricao)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentTask, "descricao", $event.target.value)
      }
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('taskDes')),
      expression: "errors.has('taskDes')"
    }],
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('validacao.campoObrigatorio'))
    }
  })])]) : _vm._e(), (!_vm.isVisualisingTask) ? _c('div', {
    staticClass: "col-xs-12 position-initial"
  }, [_c('div', {
    staticClass: "form-group col-xs-4"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "taskSituation"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('tarefaEmMassa.labels.situacao'))
    }
  }), _c('label', {
    staticClass: "control-label required-label"
  }, [_vm._v("*")]), _c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true
        }
      }),
      expression: "{ rules: { required: true } }"
    }],
    class: {
      'input': true,
      'is-danger': _vm.errors.has('task.situacao')
    },
    attrs: {
      "value": _vm.task.situacao,
      "options": _vm.tarefaStatuses,
      "label": "nome",
      "placeholder": _vm.$t('validacao.select.placeholder'),
      "data-vv-name": "task.situacao",
      "id": "taskSituation",
      "name": "taskSituation",
      "disabled": _vm.task.id ? true : false
    },
    on: {
      "input": _vm.selectSituacao
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('task.situacao')),
      expression: "errors.has('task.situacao')"
    }],
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('validacao.campoObrigatorio'))
    }
  })], 1), _c('div', {
    staticClass: "form-group col-xs-3 position-initial"
  }, [_c('label', {
    staticClass: "control-label",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('tarefaEmMassa.labels.dtVencimento'))
    }
  }), _c('div', {
    staticClass: "col-xs-12 px-0 position-initial"
  }, [_c('datepicker', {
    ref: "dataVencimento",
    staticClass: "col-xs-12 date-picker-default",
    class: {
      'is-danger-dynamic': _vm.invalid,
      'is-danger': _vm.erroDataDeVencimento
    },
    attrs: {
      "id": "dataVencimento",
      "language": _vm.datePickerLanguage,
      "format": 'dd/MM/yyyy',
      "full-month-name": "full-month-name",
      "input-class": "input-date-picker",
      "wrapper-class": "datepicker-wrapper",
      "calendar-button": "calendar-button",
      "calendar-button-icon": "fa fa-calendar",
      "disabledDates": {
        to: _vm.toDate,
        from: _vm.fromDate
      },
      "typeable": "typeable",
      "vMaskPattern": "##/##/####"
    },
    on: {
      "input": _vm.dataDeVencimentoValida
    },
    model: {
      value: (_vm.task.dataVencimento),
      callback: function($$v) {
        _vm.$set(_vm.task, "dataVencimento", $$v)
      },
      expression: "task.dataVencimento"
    }
  })], 1), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.erroDataDeVencimento),
      expression: "erroDataDeVencimento"
    }],
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('tarefa.validacao.dtVencimentoInvalida'))
    }
  })]), _c('div', {
    staticClass: "form-group col-xs-5"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "taskResp"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('tarefaEmMassa.labels.responsavel'))
    }
  }), _c('label', {
    staticClass: "control-label required-label"
  }, [_vm._v("*")]), _c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true
        }
      }),
      expression: "{ rules: { required: true } }"
    }],
    class: {
      'input': true,
      'is-danger': _vm.errors.has('task.responsavel')
    },
    attrs: {
      "options": _vm.operators,
      "label": "nome",
      "placeholder": _vm.$t('validacao.select.placeholder'),
      "id": "taskResp",
      "name": "taskResp",
      "data-vv-name": "task.responsavel"
    },
    model: {
      value: (_vm.task.responsavel),
      callback: function($$v) {
        _vm.$set(_vm.task, "responsavel", $$v)
      },
      expression: "task.responsavel"
    }
  }), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('task.responsavel')),
      expression: "errors.has('task.responsavel')"
    }],
    staticClass: "help is-danger",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('validacao.campoObrigatorio'))
    }
  })], 1)]) : _vm._e(), (!_vm.isVisualisingTask) ? _c('div', {
    staticClass: "col-xs-12"
  }, [(_vm.tipoMovimento != 'MovBan') ? _c('div', {
    staticClass: "form-group col-xs-6"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "taskSituationAuto"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('tarefaEmMassa.labels.autoConc'))
    }
  }), _c('v-select', {
    attrs: {
      "multiple": "multiple",
      "options": _vm.concilStatuses,
      "label": "nome",
      "placeholder": _vm.$t('validacao.select.placeholder'),
      "data-vv-name": "task.situacao",
      "id": "taskSituationAuto",
      "name": "taskSituationAuto"
    },
    on: {
      "input": _vm.changeAutoConcludeList
    },
    model: {
      value: (_vm.task.conclusaoAutomatica),
      callback: function($$v) {
        _vm.$set(_vm.task, "conclusaoAutomatica", $$v)
      },
      expression: "task.conclusaoAutomatica"
    }
  })], 1) : _vm._e(), _c('div', {
    staticClass: "form-group col-xs-6"
  }, [_c('div', {
    staticStyle: {
      "padding-top": "10px"
    }
  }, [_c('div', {
    staticClass: "checkbox check-success pl-0"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.task.enviarEmail),
      expression: "task.enviarEmail"
    }],
    attrs: {
      "id": "checkEnviarEmail",
      "type": "checkbox",
      "name": "checkEnviarEmail"
    },
    domProps: {
      "checked": Array.isArray(_vm.task.enviarEmail) ? _vm._i(_vm.task.enviarEmail, null) > -1 : (_vm.task.enviarEmail)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.task.enviarEmail,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.task, "enviarEmail", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.task, "enviarEmail", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.task, "enviarEmail", $$c)
        }
      }
    }
  }), _c('label', {
    staticClass: "enviar-e-mail-automa",
    attrs: {
      "for": "checkEnviarEmail"
    }
  }, [_vm._v(_vm._s(_vm.messageEmail))])])])])]) : _vm._e(), (_vm.isVisualisingTask) ? _c('div', {
    staticClass: "col-xs-12"
  }, [(_vm.idMovimento === -1 || _vm.idMovimento === '-1') ? _c('div', {
    staticClass: "col-xs-12 warning-area"
  }, [_c('h4', {
    staticClass: "detail-allotment-value font-default warning-text"
  }, [_vm._v(_vm._s(_vm.hintNoMovment))])]) : _vm._e(), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "col-xs-3 px-0"
  }, [_c('h4', {
    staticClass: "detail-title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('modalDetalhesLanc.tabTarefas.datatableHistTarefa.colNome'))
    }
  }), _c('h4', {
    staticClass: "detail-allotment-value font-default"
  }, [_vm._v(_vm._s(_vm.task.nome))])]), _c('div', {
    staticClass: "col-xs-2 px-0"
  }, [_c('h4', {
    staticClass: "detail-title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('modalDetalhesLanc.tabTarefas.datatableHistTarefa.colTipo'))
    }
  }), _c('h4', {
    staticClass: "detail-allotment-value font-default"
  }, [_vm._v(_vm._s(_vm.task.tipoVinculo.nome))])]), _c('div', {
    staticClass: "col-xs-3 px-0"
  }, [_c('h4', {
    staticClass: "detail-title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('modalDetalhesLanc.tabTarefas.datatableHistTarefa.colConclAuto'))
    }
  }), _c('h4', {
    staticClass: "detail-allotment-value font-default"
  }, [_vm._v(_vm._s(_vm.task.conclusoesAutomaticas))])]), _c('div', {
    staticClass: "col-xs-2 px-0"
  }, [_c('h4', {
    staticClass: "detail-title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('modalDetalhesLanc.tabTarefas.datatableHistTarefa.colRes'))
    }
  }), _c('h4', {
    staticClass: "detail-allotment-value font-default"
  }, [_vm._v(_vm._s(_vm.task.responsavel.nome))])]), _c('div', {
    staticClass: "col-xs-2 px-0"
  }, [_c('h4', {
    staticClass: "detail-title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('modalDetalhesLanc.tabTarefas.datatableHistTarefa.colData'))
    }
  }), _c('h4', {
    staticClass: "detail-allotment-value font-default"
  }, [_vm._v(_vm._s(_vm.formatDate(_vm.task.dataVencimento)))])])]), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h4', {
    staticClass: "detail-title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('modalDetalhesLanc.tabTarefas.datatableHistTarefa.colDesc'))
    }
  }), _c('h4', {
    staticClass: "detail-allotment-value font-default"
  }, [_vm._v(_vm._s(_vm.task.descricao))])])]) : _vm._e(), (_vm.task.historico) ? _c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('h4', {
    staticClass: "task-subtitle",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('modalDetalhesLanc.tabTarefas.titulos.historicoAcoes'))
    }
  }), _c('div', {
    staticClass: "historicoTarefaFundo"
  }, _vm._l((_vm.task.historico), function(hist) {
    return _c('div', [_c('tree-view-historic', {
      attrs: {
        "model": hist,
        "father": hist,
        "id": hist.id.toString(),
        "buttonsTitle": _vm.treeViewButtonTitle
      }
    })], 1)
  }), 0)]) : _vm._e(), _c('div', {
    staticClass: "clear"
  }), (_vm.showActionButtons) ? _c('div', {
    staticClass: "col-xs-12"
  }, [(!_vm.canReopenTask && !_vm.isVisualisingTask && _vm.canPerformTaskAction) ? _c('button-primary', {
    staticClass: "pull-right",
    attrs: {
      "label": _vm.$t('planoConciliacao.labels.salvar'),
      "id": "btnCriarTarefaTabTasks",
      "clickFunction": _vm.validate,
      "disabled": _vm.disabledBtnSaveTask
    }
  }) : _vm._e(), (_vm.canReopenTask && _vm.isVisualisingTask && _vm.canPerformTaskAction) ? _c('button-primary', {
    staticClass: "pull-right",
    attrs: {
      "label": _vm.$t('modalDetalhesLanc.tabTarefas.labels.reabrir'),
      "id": "btnReabrirTarefaTabTasks",
      "clickFunction": _vm.reopenTask
    }
  }) : _vm._e(), (_vm.isVisualisingTask && _vm.canEditTask) ? _c('button-primary', {
    staticClass: "pull-right",
    attrs: {
      "label": _vm.$t('modalDetalhesLanc.tabTarefas.labels.editarTarefa'),
      "id": "btnEditarTarefaTabTasks",
      "clickFunction": _vm.manageTask
    }
  }) : _vm._e(), _c('button-primary', {
    staticClass: "pull-right",
    attrs: {
      "label": _vm.isVisualisingTask ? _vm.$t('login.labels.voltar') : _vm.$t('conjuntoAtributo.labels.cancelar'),
      "id": "btnFecharModalDetalhesTabTasks",
      "customClass": "secondary",
      "clickFunction": _vm.isVisualisingTask || !_vm.task.id ? _vm.cancelManagement : _vm.goBack
    }
  })], 1) : _vm._e()]) : (_vm.withTaskBonded) ? _c('div', {
    staticClass: "px-0",
    staticStyle: {
      "padding-top": "21px"
    }
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "col-xs-9 px-0"
  }, [_c('h4', {
    staticClass: "task-subtitle",
    domProps: {
      "innerHTML": _vm._s(_vm.taskDetailsHeaderTitle)
    }
  })]), _c('div', {
    staticClass: "col-xs-3 pull-right"
  }, [_c('button-primary', {
    staticClass: "pull-right",
    attrs: {
      "label": _vm.taskDetailsHeaderButton,
      "id": "btnCriarTarefaTabTasks",
      "clickFunction": _vm.viewOldTask
    }
  })], 1)]), (_vm.hasActiveTask && _vm.activeTask) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "col-xs-3 px-0"
  }, [_c('h4', {
    staticClass: "detail-title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('modalDetalhesLanc.tabTarefas.datatableHistTarefa.colNome'))
    }
  }), _c('h4', {
    staticClass: "detail-allotment-value font-default"
  }, [_vm._v(_vm._s(_vm.activeTask.nome))])]), _c('div', {
    staticClass: "col-xs-2 px-0"
  }, [_c('h4', {
    staticClass: "detail-title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('modalDetalhesLanc.tabTarefas.datatableHistTarefa.colTipo'))
    }
  }), _c('h4', {
    staticClass: "detail-allotment-value font-default"
  }, [_vm._v(_vm._s(_vm.activeTask.tipoVinculo.nome))])]), _c('div', {
    staticClass: "col-xs-3 px-0"
  }, [_c('h4', {
    staticClass: "detail-title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('modalDetalhesLanc.tabTarefas.datatableHistTarefa.colConclAuto'))
    }
  }), _c('h4', {
    staticClass: "detail-allotment-value font-default"
  }, [_vm._v(_vm._s(_vm.activeTask.conclusoesAutomaticas))])]), _c('div', {
    staticClass: "col-xs-2 px-0"
  }, [_c('h4', {
    staticClass: "detail-title",
    staticStyle: {
      "margin-bottom": "0px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('modalDetalhesLanc.tabTarefas.datatableHistTarefa.colRes'))
    }
  }), _c('tr', {
    staticStyle: {
      "padding": "0px",
      "width": "100%"
    }
  }, [_c('td', [_c('h4', {
    staticClass: "detail-allotment-value font-default"
  }, [_vm._v(_vm._s(_vm.activeTask.responsavel.nome))])]), (_vm.canAssignToTask) ? _c('td', {
    staticStyle: {
      "padding-left": "5px"
    }
  }, [(_vm.canPerformTaskAction) ? _c('button-primary', {
    staticStyle: {
      "min-width": "22px",
      "padding": "0px",
      "margin": "0px"
    },
    attrs: {
      "title": _vm.$t('modalDetalhesLanc.tabTarefas.labels.assumirTarefa'),
      "faIcon": "fa fa-exchange",
      "id": "btnAssumirTarefaTabTarefas",
      "clickFunction": _vm.assignTaskToLoggedUser
    }
  }) : _vm._e()], 1) : _vm._e()])]), _c('div', {
    staticClass: "col-xs-2 px-0"
  }, [_c('h4', {
    staticClass: "detail-title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('modalDetalhesLanc.tabTarefas.datatableHistTarefa.colData'))
    }
  }), _c('h4', {
    staticClass: "detail-allotment-value font-default"
  }, [_vm._v(_vm._s(_vm.dueDateFormatted))])])]), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h4', {
    staticClass: "detail-title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('modalDetalhesLanc.tabTarefas.datatableHistTarefa.colDesc'))
    }
  }), _c('h4', {
    staticClass: "detail-allotment-value font-default"
  }, [_vm._v(_vm._s(_vm.activeTask.descricao))])])]) : _vm._e(), (_vm.hasActiveTask && _vm.canPerformTaskAction) ? _c('div', {
    staticClass: "col-xs-12",
    attrs: {
      "id": "ocurrence-task-form"
    }
  }, [_c('h4', {
    staticClass: "task-subtitle",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('modalDetalhesLanc.tabTarefas.titulos.atualizarStatus'))
    }
  }), _c('div', {
    staticClass: "col-xs-12 px-0"
  }, [_c('div', {
    staticClass: "form-group col-xs-4"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "taskSituation"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('tarefaEmMassa.labels.situacao'))
    }
  }), _c('v-select', {
    attrs: {
      "options": _vm.tarefaStatuses,
      "label": "nome",
      "placeholder": _vm.$t('validacao.select.placeholder'),
      "data-vv-name": "taskOcurrence.situacao",
      "id": "taskSituation",
      "name": "taskSituation"
    },
    on: {
      "input": _vm.onSituationChanged
    },
    model: {
      value: (_vm.taskOcurrence.situacao),
      callback: function($$v) {
        _vm.$set(_vm.taskOcurrence, "situacao", $$v)
      },
      expression: "taskOcurrence.situacao"
    }
  })], 1), _c('div', {
    staticClass: "col-md-8 col-sm-8 col-xs-11"
  }, [_c('div', {
    staticClass: "col-xs-12 px-0"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "taskDes"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('modalDetalhesLanc.tabTarefas.datatableHistTarefa.colDesc'))
    }
  })]), _c('div', {
    staticClass: "col-xs-11 px-0"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.taskOcurrence.observacaoHistorico),
      expression: "taskOcurrence.observacaoHistorico"
    }],
    staticClass: "form-control",
    class: {
      'input': true,
      'is-danger': _vm.errors.has('taskDes')
    },
    attrs: {
      "type": "text",
      "id": "taskDes",
      "name": "taskDes",
      "maxlength": "4000",
      "rows": "2",
      "cols": "130"
    },
    domProps: {
      "value": (_vm.taskOcurrence.observacaoHistorico)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.taskOcurrence, "observacaoHistorico", $event.target.value)
      }, _vm.onDescriptionChanged]
    }
  })]), _c('div', {
    staticClass: "col-xs-1 input-button pull-left px-0"
  }, [(_vm.canPerformTaskAction) ? _c('button-primary', {
    staticClass: "filterButton filter-input-tag",
    attrs: {
      "title": _vm.$t('modalDetalhesLanc.tabTarefas.labels.salvarOcorrencia'),
      "faIcon": "fa fa-check",
      "disabled": _vm.disabledBtnChangeStatusTask,
      "id": "btnSalvarOcorrenciaTarefa",
      "clickFunction": _vm.updateTaskStatus
    }
  }) : _vm._e()], 1)])])]) : _vm._e(), _c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('h4', {
    staticClass: "task-subtitle",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('modalDetalhesLanc.tabTarefas.titulos.historicoTarefas'))
    }
  }), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('v-client-table', {
    staticClass: "data-table custom-data-table allotment-data-table",
    attrs: {
      "data": _vm.taskHistory,
      "columns": _vm.columns,
      "options": _vm.options,
      "name": "histTarefas"
    },
    scopedSlots: _vm._u([{
      key: "acoes",
      fn: function(props) {
        return [_c('button', {
          staticClass: "fa fa-eye action table-icon",
          attrs: {
            "title": _vm.tipAcaoDetalhes
          },
          on: {
            "click": function($event) {
              return _vm.viewOldTask(props.row)
            }
          }
        })]
      }
    }])
  })], 1)])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('video', {
    attrs: {
      "id": "video-player",
      "loop": "loop",
      "autoplay": "autoplay"
    }
  }, [_c('source', {
    attrs: {
      "src": "https://s3-sa-east-1.amazonaws.com/midias-banking/Tarefas.mp4",
      "type": "video/mp4"
    }
  })])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1d6ea436", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1d6ea436"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/modals/gridDetailsModal/tabTasks/tabTasks.pug
// module id = 1378
// module chunks = 0